import { Polygon } from '@react-google-maps/api';
import { PolygonUnitType } from '../../../../types/mvpMap';
import React from 'react';

const PolygonUnit = ({
  polygonCoords,
}: PolygonUnitType) => {
  return (
    <Polygon
      paths={polygonCoords} // Array of coordinates to draw the polygon
      options={{
        fillColor: 'rgba(140, 240, 26, 0.18)',
        fillOpacity: 1,
        strokeColor: 'rgba(140, 240, 26, 1)',
        strokeOpacity: 1,
        strokeWeight: 2,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 1,
      }}
    />
  );
};

export default React.memo(PolygonUnit);
